import { CareType } from '@/types/care_type';

const getCareTypeOptions = (): { display: string; value: CareType }[] => {
  return [
    { display: 'Babysitter', value: CareType.BABYSITTER },
    { display: 'Nanny', value: CareType.NANNY },
    { display: 'Housekeeper', value: CareType.HOUSEKEEPING },
    { display: 'Pet care', value: CareType.PET_CARE },
    { display: 'Special needs', value: CareType.SPECIAL_NEEDS },
    { display: 'Care companion', value: CareType.COMPANION_CARE },
  ];
};

export const getCareTypeDisplayName = (careType: string): string => {
  if (!careType) return '';
  const careTypeMap: Record<string, string> = {
    BABYSITTER: 'Babysitter',
    NANNY: 'Nanny',
    HOUSEKEEPING: 'Housekeeper',
    PET_CARE: 'Pet care',
    SPECIAL_NEEDS: 'Special needs care',
    COMPANION_CARE: 'Companion care',
    CHILD_CARE: 'Child Care',
  };
  return careTypeMap[careType.toUpperCase()] || '';
};

export default getCareTypeOptions;
